import { createRoute, redirect } from '@tanstack/react-router'

import { casinoRoute } from '.'

// `/casino` is only a layout: its children are `$category` and `$category/$game`,
// so the bare path matched the layout and rendered an empty <Outlet> — a blank
// screen with no not-found page, because the match itself succeeded. The casino
// home is the site root (`/` renders <Casino category="inicio" />), so send it
// there. The FunSports lobby posts `navigate` with this path (see
// src/components/sports/sports-lobby-host.tsx), and it is a plausible bookmark.
export const casinoIndexRoute = createRoute({
  getParentRoute: () => casinoRoute,
  path: '/',
  // replace: coming back from the casino must not bounce through /casino again.
  beforeLoad: () => {
    throw redirect({ to: '/', replace: true })
  },
})
